import { Component, EventEmitter, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedModalDataType } from "../modal-service.service";

@Component({
  selector: "app-shared-modal-confirm",
  templateUrl: "./modal-confirm.component.html",
  styleUrls: ["./modal-confirm.component.css"],
})
export class ModalConfirmComponent {
  data: SharedModalDataType<any> = {
    title: "Missing Title Parameter",
    body: "Default Body",
  };
  @Output() pressedConfirm = new EventEmitter<void>();
  @Output() pressedCancel = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal) {}

  // Resto del código del componente

  confirm() {
    this.pressedConfirm.emit();
  }

  cancel() {
    this.pressedCancel.emit();
  }
}
